<template>
  <div id="main-menu" v-if="isLoggedIn">
    <div class="bg-primary d-flex">
      <span class="mr-auto p-2">
        <span class="btn-toggle">
          <span class="fas fa-bars" onclick="toggle_m_menu();" ></span>
        </span>
      </span>
      <span class="p-2 truncate" @click="show_profile_list()">
        <span class="fas fa-id-card"></span>
        <span> {{ current_profile.name }} </span> 
        <span v-show="many_profile" class="fas fa-arrow-circle-down"></span>
      </span>
      <span class="p-2">|</span>
      <span class="p-2" @click="signOut">
        <span class="fas fa-door-closed"></span>
        <span class="not_on_sm_mobile">Sign Out</span>
      </span>
    </div>
    <modalProfileList/>
  </div>
</template>

<script>
import { mapState } from "vuex";
import modalProfileList from "@/components/auth/ModalProfileList";

export default {
  components: {
    modalProfileList
  },
  computed: {
    ...mapState(["isLoggedIn", "profile_list","current_profile","isStaffMember"]),
    many_profile(){
      return (this.isStaffMember || this.profile_list.length>1);
    }
 },
  methods: {
    show_profile_list: function(){
      if(this.many_profile){
        this.$bvModal.show('modal-profile-list')
      }
    },
    signOut: function() {
      this.$store.dispatch("signOut")
      .then(() => {
        this.$router.push("/");
      });
    },
  },
};
</script>
